export default __webpack_public_path__ + "static/media/minus.976610f2.svg";